import React, {useRef, useState} from 'react';
import { BsPauseCircle, BsPlayCircle } from 'react-icons/bs';
import { ImPlay2 } from 'react-icons/im';
import z from '../assets/meal.mp4';

const Intro = () => {
    const [playVideo, setPlayVideo] = useState(false);
    const vidRef = useRef();
    const handleVideo = () => {
        setPlayVideo((prevPlayVideo) => !prevPlayVideo);
        if(playVideo) {
            vidRef.current.pause();
        } else {
            vidRef.current.play();
        }
    }
  return (
    <div className='relative bg-banner h-[750px]'>
        <video 
        src={z}  
        type='video/mp4' 
        loop 
        controls={false} 
        muted 
        ref={vidRef}
        className=''/>
        <div className='absolute inset-0 flex justify-center items-center bg-play bg-center bg-cover bg-repeat bg-fixed h-[750px]'>
            <div onClick={handleVideo} className='w-[100px] h-[100px] rounded-[50%] cursor-pointer flex justify-center items-center'>
                {playVideo ? <BsPauseCircle color='#fff' size={300}/> : <BsPlayCircle color='#fff' size={300}/>} 
            </div>
        </div>
    </div>
  )
}

export default Intro